import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-ritwik-custom-date',
  standalone: true,
  imports: [MatIconModule, ReactiveFormsModule],
  templateUrl: './ritwik-custom-date.component.html',
  styleUrl: './ritwik-custom-date.component.scss'
})
export class RitwikCustomDateComponent {
constructor(
  private _toaster: ToastrService,
  private matdialogRef: MatDialogRef<RitwikCustomDateComponent>
){}

startDate = new FormControl('');
endDate = new FormControl('');

onCloseClick(){
this.matdialogRef.close(false)
}

onClearClick(){
this.startDate.setValue('')
this.endDate.setValue('')
}

onSearchClick(){
this.matdialogRef.close({
  result: {
    startDate: this.startDate?.value || '',
    endDate: this.endDate?.value || '',
  }
})
}
}
